import { useRef } from 'react';
import { IconButton } from '@coolblue-development/becky';
import PaperclipIcon from '../../../../../../assets/paperclip.svg';
import { SUPPORTED_ATTACHMENT_EXTENSIONS } from '../../../../../../models/Attachment';

interface AttachmentUploadButtonProps {
  onFilesSelected: (files: FileList) => void;
  disabled?: boolean;
}

const AttachmentUploadButton = ({ onFilesSelected, disabled }: AttachmentUploadButtonProps): JSX.Element => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    onFilesSelected(files);

    if (inputRef.current) {
      inputRef.current.value = '';
    }
  };

  const onClick = (): void => {
    inputRef.current?.click();
  };

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        multiple
        accept={SUPPORTED_ATTACHMENT_EXTENSIONS.join(',')}
        onChange={handleFileSelect}
        style={{ display: 'none' }}
        data-testid="attachment-file-input"
      />
      <IconButton
        preset="text"
        onClick={onClick}
        disabled={disabled}
        iconSize="small"
        data-testid="attachment-upload-button"
        sx={{
          width: 'auto',
          height: 'auto',
          padding: '8px',
          ':hover': { background: '#F3F3F3' }
        }}
      >
        <PaperclipIcon />
      </IconButton>
    </>
  );
};

export default AttachmentUploadButton;
